import React from "react";
import Seo from "../components/Seo";

// Placeholder copy: have it reviewed/replaced by the business's legal text before launch.
function LegalPage({ title, description, children }) {
  return (
    <div className="container-x py-12 max-w-3xl" data-testid="legal-page">
      <Seo title={title} description={description} />
      <h1 className="font-serif text-4xl md:text-5xl">{title}</h1>
      <div className="mt-8 space-y-4 text-black/80">{children}</div>
    </div>
  );
}

export function Terms() {
  return (
    <LegalPage title="Terms of Service" description="The terms that apply when you use Inkstead.">
      <p>By creating an account or using Inkstead you agree to these terms.</p>
      <h2 className="font-serif text-2xl pt-4">Your account</h2>
      <p>You are responsible for your account credentials and for the content you post. Provide accurate information and do not impersonate others.</p>
      <h2 className="font-serif text-2xl pt-4">Bookings</h2>
      <p>Inkstead connects clients and tattoo artists. Appointments, pricing and services are agreed directly between them.</p>
      <h2 className="font-serif text-2xl pt-4">Content and conduct</h2>
      <p>Do not post unlawful, abusive or infringing content. We may remove content or suspend accounts that violate these terms.</p>
    </LegalPage>
  );
}

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy" description="How Inkstead collects, uses and protects your information.">
      <p>This policy explains what information Inkstead handles and why.</p>
      <h2 className="font-serif text-2xl pt-4">Information we collect</h2>
      <p>Account details (name, email, hashed password), profile and portfolio content, bookings, and usage analytics.</p>
      <h2 className="font-serif text-2xl pt-4">How we use it</h2>
      <p>To operate the platform, process bookings, send account emails and improve the service. We do not sell your email address.</p>
      <h2 className="font-serif text-2xl pt-4">Your choices</h2>
      <p>You can update your profile or delete your account at any time.</p>
    </LegalPage>
  );
}
